const doc = [({"en":({"adminConstantHotelChildrenSettingMealType":({"included":"Included", "notIncluded":"Children's meals", "sameAsAdult":"Same as adult"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;